module.exports = __webpack_public_path__ + "img/address-add@2x.0d5d662b.png";